import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

// const config = {
//   headers: {
//     Authorization: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
//     "Content-Type": "application/json",
//     staffId: 20,
//   },
// };

const baseUrl = process.env.REACT_APP_BASE_URI;

/** Prevent browser/proxy 304 responses with empty bodies from wiping Redux GET state */
const noCacheGetConfig = () => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

const withCacheBust = (path) => {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}_nc=${Date.now()}`;
};

const user = JSON.parse(localStorage.getItem("user_data")) || {};

const accountType = user?.account_type;

const initialState = {
  commonLoading: false,
  commonSuccess: false,
  commonError: false,
  commonMessage: null,
  commonData: null,

  commonLoadingOne: false,
  commonSuccessOne: false,
  commonErrorOne: false,
  commonMessageOne: null,
  commonDataOne: null,

  commonGetLoading: false,
  commonGetSuccess: false,
  commonGetError: false,
  commonGetMessage: null,
  commonGetData: null,

  commonGetOneLoading: false,
  commonGetOneSuccess: false,
  commonGetOneError: false,
  commonGetOneMessage: null,
  commonGetOneData: null,

  commonGetTwoLoading: false,
  commonGetTwoSuccess: false,
  commonGetTwoError: false,
  commonGetTwoMessage: null,
  commonGetTwoData: null,

  commonGetThirdLoading: false,
  commonGetThirdSuccess: false,
  commonGetThirdError: false,
  commonGetThirdMessage: null,
  commonGetThirdData: null,

  commonGetFourthLoading: false,
  commonGetFourthSuccess: false,
  commonGetFourthError: false,
  commonGetFourthMessage: null,
  commonGetFourthData: null,

  commonGetFourthLoading: false,
  commonGetFourthSuccess: false,
  commonGetFourthError: false,
  commonGetFourthMessage: null,
  commonGetFourthData: null,

  commonNotificationLpoading: false,
  commonNotificationSuccess: false,
  commonNotificationError: false,
  commonNotificationMessage: null,
  commonNotificationData: null,
};

export const commonSaveData = createAsyncThunk(
  "commonSaveData",
  async (body) => {
    const { path, data, method = "post" } = body;
    const url = baseUrl + path;
    const httpMethod = String(method).toLowerCase();

    // Read accountType dynamically so it reflects the current logged-in user
    const currentUser = JSON.parse(localStorage.getItem("user_data")) || {};
    const currentAccountType = currentUser?.account_type;

    const result = {
      data: {
        status: 200,
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const runRequest = () => {
      if (httpMethod === "delete") {
        return axios.delete(url, { ...config, data: data ?? {} });
      }
      if (httpMethod === "put") {
        return axios.put(url, data, config);
      }
      return axios.post(url, data, config);
    };

    return await runRequest()
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const commonSaveDataOne = createAsyncThunk(
  "commonSaveDataOne",
  async (body) => {
    const { path, data } = body;
    const url = baseUrl + path;

    const currentUser = JSON.parse(localStorage.getItem("user_data")) || {};
    const currentAccountType = currentUser?.account_type;

    return await axios
      .post(url, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);
// axios
//   .get(`${baseUrl}${path}`, config)
export const commonGetData = createAsyncThunk("commonGetData", async (path) => {
  return await axios
    .get(`${baseUrl}${withCacheBust(path)}`, noCacheGetConfig())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          message: "No Internet Connection Found",
        };
        return data;
      } else {
        let data = {
          response: {
            data: {
              message: error.message,
            },
          },
        };
        return error;
      }
    });
});

export const commonGetDataOne = createAsyncThunk(
  "commonGetDataOne",
  async (path) => {
    return await axios
      .get(`${baseUrl}${withCacheBust(path)}`, noCacheGetConfig())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          let data = {};
          data.data = error.response.data;
          data.status = error.response.status;
          return data;
        }
      });
  }
);

export const commonGetDataTwo = createAsyncThunk(
  "commonGetDataTwo",
  async (path) => {
    return await axios
      .get(`${baseUrl}${withCacheBust(path)}`, noCacheGetConfig())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            message: "No Internet Connection Found",
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const commonGetDataThird = createAsyncThunk(
  "commonGetDataThird",
  async (path) => {
    return await axios
      .get(`${baseUrl}${withCacheBust(path)}`, noCacheGetConfig())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const commonGetDataFourth = createAsyncThunk(
  "commonGetDataFourth",
  async (path) => {
    // Debug: Log the full URL being called
    console.log("commonGetDataFourth - Full URL:", `${baseUrl}${path}`);
    console.log("commonGetDataFourth - Base URL:", baseUrl);
    console.log("commonGetDataFourth - Path:", path);
    console.log("commonGetDataFourth - Config:", config);
    
    return await axios
      .get(`${baseUrl}${withCacheBust(path)}`, noCacheGetConfig())
      .then((response) => {
        console.log("commonGetDataFourth - Response:", response);
        return response;
      })
      .catch((error) => {
        console.error("commonGetDataFourth - Error:", error);
        console.error("commonGetDataFourth - Error Response:", error.response);
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);
export const commonNotification = createAsyncThunk(
  "commonNotification",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

const CommonSlice = createSlice({
  name: "common",
  initialState,

  reducers: {
    initSaveState: (state) => {
      state.commonLoading = false;
      state.commonSuccess = false;
      state.commonError = false;
      state.commonMessage = null;
      state.commonData = null;
    },

    initState: (state) => {
      state.commonLoading = false;
      state.commonSuccess = false;
      state.commonError = false;
      state.commonMessage = null;
      state.commonData = null;

      state.commonGetLoading = false;
      state.commonGetSuccess = false;
      state.commonGetError = false;
      state.commonGetMessage = null;
      state.commonGetData = null;

      state.commonGetOneLoading = false;
      state.commonGetOneSuccess = false;
      state.commonGetOneError = false;
      state.commonGetOneMessage = null;
      state.commonGetOneData = null;

      state.commonGetTwoLoading = false;
      state.commonGetTwoSuccess = false;
      state.commonGetTwoError = false;
      state.commonGetTwoMessage = null;
      state.commonGetTwoData = null;

      state.commonGetThirdLoading = false;
      state.commonGetThirdSuccess = false;
      state.commonGetThirdError = false;
      state.commonGetThirdMessage = null;
      state.commonGetThirdData = null;
    },
    initCommonState: (state) => {
      state.commonLoading = false;
      state.commonSuccess = false;
      state.commonError = false;
      state.commonMessage = null;
      state.commonData = null;

      state.commonLoadingOne = false;
      state.commonSuccessOne = false;
      state.commonErrorOne = false;
      state.commonMessageOne = null;
      state.commonDataOne = null;

      state.commonGetLoading = false;
      state.commonGetSuccess = false;
      state.commonGetError = false;
      state.commonGetMessage = null;
      state.commonGetData = null;

      state.commonGetOneLoading = false;
      state.commonGetOneSuccess = false;
      state.commonGetOneError = false;
      state.commonGetOneMessage = null;
      state.commonGetOneData = null;

      state.commonGetTwoLoading = false;
      state.commonGetTwoSuccess = false;
      state.commonGetTwoError = false;
      state.commonGetTwoMessage = null;
      state.commonGetTwoData = null;

      state.commonGetThirdLoading = false;
      state.commonGetThirdSuccess = false;
      state.commonGetThirdError = false;
      state.commonGetThirdMessage = null;
      state.commonGetThirdData = null;

      state.commonGetFourthLoading = false;
      state.commonGetFourthSuccess = false;
      state.commonGetFourthError = false;
      state.commonGetFourthMessage = null;
      state.commonGetFourthData = null;
    },
    initNotification: (state) => {
      state.commonNotificationLpoading = false;
      state.commonNotificationSuccess = false;
      state.commonNotificationError = false;
      state.commonNotificationMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(commonNotification.pending, (state, action) => {
      state.commonNotificationLpoading = true;
      state.commonNotificationSuccess = false;
      state.commonNotificationError = false;
      state.commonNotificationMessage = null;
      state.commonNotificationData = null;
    });

    builder.addCase(commonNotification.fulfilled, (state, action) => {
      state.commonNotificationLpoading = false;
      state.commonNotificationSuccess = true;
      state.commonNotificationError = false;
      state.commonNotificationMessage =
        action.payload.status == 200
          ? action.payload.data.message
          : action.payload.response.data.message;
      state.commonNotificationData =
        action.payload.status == 200
          ? action.payload.data.data
          : action.payload.response.data.data;
    });

    builder.addCase(commonNotification.rejected, (state, action) => {
      state.commonNotificationLpoading = false;
      state.commonNotificationSuccess = true;
      state.commonNotificationError = false;
      state.commonNotificationMessage = null;
      state.commonNotificationData = null;
    });
    // -----------------------------------------

    builder.addCase(commonGetData.pending, (state, action) => {
      state.commonGetLoading = true;
      state.commonGetSuccess = false;
      state.commonGetError = false;
      state.commonGetMessage = null;
      // Do not clear commonGetData — pending + 304 used to leave null and empty grids
    });

    builder.addCase(commonGetData.fulfilled, (state, action) => {
      const status = action.payload.status;
      // 304 Not Modified — no body; only succeed if we already have data in store
      if (status == 304 || status == "304") {
        state.commonGetLoading = false;
        if (state.commonGetData != null) {
          state.commonGetSuccess = true;
          state.commonGetError = false;
        } else {
          state.commonGetSuccess = false;
          state.commonGetError = true;
          state.commonGetMessage = "Unable to load data (cached empty response). Please refresh.";
        }
        return;
      }
      if (status == 200 || status == "200") {
        const body = action.payload.data;
        const isOk =
          body?.status === true ||
          body?.status === "true" ||
          body?.code === 200 ||
          body?.code === "200";
        if (isOk) {
          state.commonGetLoading = false;
          state.commonGetSuccess = true;
          state.commonGetError = false;
          state.commonGetMessage = body.message;
          state.commonGetData = body.data;
        } else if (Array.isArray(body)) {
          state.commonGetLoading = false;
          state.commonGetSuccess = true;
          state.commonGetError = false;
          state.commonGetMessage = null;
          state.commonGetData = body;
        } else {
          state.commonGetLoading = false;
          state.commonGetSuccess = false;
          state.commonGetError = true;
          state.commonGetMessage = action.payload.data?.message
            ? action.payload.data.message
            : action.payload.data?.msg;
          state.commonGetData = null;
        }
      } else {
        state.commonGetLoading = false;
        state.commonGetSuccess = false;
        state.commonGetError = true;
        state.commonGetMessage = action.payload?.response?.data?.message || "Request failed";
        state.commonGetData = action.payload?.response?.data?.data || null;
      }
    });

    builder.addCase(commonGetData.rejected, (state, action) => {
      state.commonGetLoading = false;
      state.commonGetSuccess = true;
      state.commonGetError = false;
      state.commonGetMessage = null;
      state.commonGetData = null;
    });
    // -----------------------------------------
    builder.addCase(commonGetDataOne.pending, (state, action) => {
      state.commonGetOneLoading = true;
      state.commonGetOneSuccess = false;
      state.commonGetOneError = false;
      state.commonGetOneMessage = null;
    });
    builder.addCase(commonGetDataOne.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 304 || status == "304") {
        state.commonGetOneLoading = false;
        if (state.commonGetOneData != null) {
          state.commonGetOneSuccess = true;
          state.commonGetOneError = false;
        } else {
          state.commonGetOneSuccess = false;
          state.commonGetOneError = true;
        }
        return;
      }
      if (status == 200) {
        const body = action.payload.data || {};
        const isOk =
          body.status === true ||
          body.status === "true" ||
          body.code === 200 ||
          body.code === "200";
        if (isOk) {
          state.commonGetOneLoading = false;
          state.commonGetOneSuccess = true;
          state.commonGetOneError = false;
          state.commonGetOneMessage = body.message;
          state.commonGetOneData = body.data;
        } else {
          state.commonGetOneLoading = false;
          state.commonGetOneSuccess = false;
          state.commonGetOneError = true;
          // state.commonGetOneMessage = action.payload.data.message
          //   ? action.payload.data.message
          //   : action.payload.response.data.message;
          state.commonGetOneData = null;
        }
      }
    });
    builder.addCase(commonGetDataOne.rejected, (state, action) => {
      state.commonGetOneLoading = false;
      state.commonGetOneSuccess = true;
      state.commonGetOneError = false;
      state.commonGetOneMessage = null;
      state.commonGetOneData = null;
    });
    // -----------------------------------------
    builder.addCase(commonGetDataTwo.pending, (state, action) => {
      state.commonGetTwoLoading = true;
      state.commonGetTwoSuccess = false;
      state.commonGetTwoError = false;
      state.commonGetTwoMessage = null;
      state.commonGetTwoData = null;
    });
    builder.addCase(commonGetDataTwo.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 200) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.commonGetTwoLoading = false;
          state.commonGetTwoSuccess = true;
          state.commonGetTwoError = false;
          state.commonGetTwoMessage = action.payload.data.message;
          state.commonGetTwoData = action.payload.data.data;
        } else {
          state.commonGetTwoLoading = false;
          state.commonGetTwoSuccess = false;
          state.commonGetTwoError = true;
          state.commonGetTwoMessage = "";
          state.commonGetTwoData = null;
        }
      } else {
        state.commonGetTwoLoading = false;
        state.commonGetTwoSuccess = false;
        state.commonGetTwoError = true;
        // state.commonGetTwoMessage = action.payload.data.message;
        state.commonGetTwoMessage = "";
        state.commonGetTwoData = null;
      }
    });
    builder.addCase(commonGetDataTwo.rejected, (state, action) => {
      state.commonGetTwoLoading = false;
      state.commonGetTwoSuccess = false;
      state.commonGetTwoError = true;
      state.commonGetTwoMessage = null;
      state.commonGetTwoData = null;
    });

    // -----------------------------------------
    builder.addCase(commonGetDataThird.pending, (state, action) => {
      state.commonGetThirdLoading = true;
      state.commonGetThirdSuccess = false;
      state.commonGetThirdError = false;
      state.commonGetThirdMessage = null;
      state.commonGetThirdData = null;
    });
    builder.addCase(commonGetDataThird.fulfilled, (state, action) => {
      const status = action.payload.status;
      state.commonGetThirdLoading = false;
      state.commonGetThirdSuccess = status == 200 ? true : false;
      state.commonGetThirdError = status == 200 ? false : true;
      state.commonGetThirdMessage =
        status == 200
          ? action.payload.data.message
          : action.payload.response.data.message;
      state.commonGetThirdData =
        status == 200 ? action.payload.data.data : null;
    });
    builder.addCase(commonGetDataThird.rejected, (state, action) => {
      state.commonGetThirdLoading = false;
      state.commonGetThirdSuccess = true;
      state.commonGetThirdError = false;
      state.commonGetThirdMessage = null;
      state.commonGetThirdData = null;
    });
    // -------------------------------------------------
    // -----------------------------------------
    builder.addCase(commonGetDataFourth.pending, (state, action) => {
      state.commonGetFourthLoading = true;
      state.commonGetFourthSuccess = false;
      state.commonGetFourthError = false;
      state.commonGetFourthMessage = null;
      state.commonGetFourthData = null;
    });
    builder.addCase(commonGetDataFourth.fulfilled, (state, action) => {
      const status = action.payload.status;
      state.commonGetFourthLoading = false;
      state.commonGetFourthSuccess = status == 200 ? true : false;
      state.commonGetFourthError = status == 200 ? false : true;
      state.commonGetFourthMessage =
        status == 200
          ? action.payload.data.message
          : action.payload.response.data.message;
      state.commonGetFourthData =
        status == 200 ? action.payload.data.data : null;
    });
    builder.addCase(commonGetDataFourth.rejected, (state, action) => {
      state.commonGetFourthLoading = false;
      state.commonGetFourthSuccess = true;
      state.commonGetFourthError = false;
      state.commonGetFourthMessage = null;
      state.commonGetFourthData = null;
    });
    // -------------------------------------------------
    builder.addCase(commonSaveData.pending, (state) => {
      state.commonLoading = true;
      state.commonSuccess = false;
      state.commonError = false;
      state.commonMessage = null;
      state.commonData = null;
    });
    builder.addCase(commonSaveData.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.commonLoading = false;
          state.commonSuccess = true;
          state.commonError = false;
          state.commonMessage = action.payload.data.message;
          state.commonData = action.payload.data.data;
        } else {
          state.commonLoading = false;
          state.commonSuccess = false;
          state.commonError = true;
          state.commonMessage =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.commonLoading = false;
        state.commonSuccess = false;
        state.commonError = true;
        state.commonMessage =
          action.payload?.response?.data?.message
            ? action.payload?.response?.data?.message
            : action.payload.message;
        state.commonData = null;
      }
    });
    builder.addCase(commonSaveData.rejected, (state) => {
      state.commonLoading = false;
      state.commonSuccess = false;
      state.commonError = true;
      state.commonMessage = null;
      state.commonData = null;
    });

    // -------------------------------------------------
    builder.addCase(commonSaveDataOne.pending, (state) => {
      state.commonLoadingOne = true;
      state.commonSuccessOne = false;
      state.commonErrorOne = false;
      state.commonMessageOne = null;
      state.commonDataOne = null;
    });
    builder.addCase(commonSaveDataOne.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.commonLoadingOne = false;
          state.commonSuccessOne = true;
          state.commonErrorOne = false;
          state.commonMessageOne = action.payload.data.message;
          state.commonDataOne = action.payload.data.data;
        } else {
          state.commonLoadingOne = false;
          state.commonSuccessOne = false;
          state.commonErrorOne = true;
          state.commonMessageOne =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.commonLoadingOne = false;
        state.commonSuccessOne = false;
        state.commonErrorOne = true;
        state.commonMessageOne =
          action.payload.response?.data?.message || action.payload.message;
        state.commonDataOne = null;
      }
    });
    builder.addCase(commonSaveDataOne.rejected, (state) => {
      state.commonLoadingOne = false;
      state.commonSuccessOne = false;
      state.commonErrorOne = true;
      state.commonMessageOne = null;
      state.commonDataOne = null;
    });
  },
});

export const { initState, initSaveState, initCommonState, initNotification } =
  CommonSlice.actions;

export default CommonSlice.reducer;
